"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepThreeOnlineFirstAppointment = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const atome_1 = require("../../../../atome");
const organisms_1 = require("../../../../organisms");
const Appointment_service_1 = __importDefault(require("../../../../../services/Appointment.service"));
const User_service_1 = __importDefault(require("../../../../../services/User.service"));
const hooks_1 = require("../../../../../store/hooks");
const reducers_1 = require("../../../../../store/reducers");
const GlobalStyles_1 = require("../../../../../helper/GlobalStyles");
const doctorslot_enum_1 = require("../../../../../enums/doctorslot.enum");
const atome_2 = require("../../../../atome");
const OnlineFirstAppointment_style_1 = require("../OnlineFirstAppointment.style");
const Breakpoints_1 = require("../../../../../helper/Breakpoints");
// @ts-ignore
function StepThreeOnlineFirstAppointment({ navigation, onlineFirstAppointmentInfo, }) {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const userInformation = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const [error, setError] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const bookAppointment = async () => {
        setLoading(true);
        if (onlineFirstAppointmentInfo.selectedSlot) {
            const appointmentData = {
                doctorName: onlineFirstAppointmentInfo.doctorName,
                doctorId: onlineFirstAppointmentInfo.doctorId,
                startDate: onlineFirstAppointmentInfo.selectedSlot.start,
                endDate: onlineFirstAppointmentInfo.selectedSlot.end,
                type: doctorslot_enum_1.DOCTOR_SLOT_SUBTYPE.ONLINE,
                appointmentType: 'firstAppointment',
                comment: 'Von Patient erstellt',
            };
            const doctorResponse = await User_service_1.default.assignDoctorWithType(parseInt(userInformation.id), parseInt(onlineFirstAppointmentInfo.doctorId), 'main');
            if (doctorResponse.error) {
                console.log(doctorResponse);
                setLoading(false);
                return;
            }
            await async_storage_1.default.setItem('appointmentData', JSON.stringify({
                ...appointmentData,
            }));
            await async_storage_1.default.setItem('appointmentDoctor', JSON.stringify(onlineFirstAppointmentInfo.doctorId));
            appointmentData.doctorName = appointmentData.doctorName.includes('.')
                ? appointmentData.doctorName.split('. ')[1]
                : appointmentData.doctorName;
            Appointment_service_1.default.createAppointment(appointmentData).then(res => {
                if (res.error) {
                    setError(true);
                    if (res.message.response.status === 401) {
                        dispatch((0, reducers_1.setAuth)({ isAuthenticated: false }));
                        navigation.navigate('Login');
                        setError(false);
                    }
                    console.log(res.message);
                    setLoading(false);
                }
                setLoading(false);
                navigation.navigate('OnlineFirstAppointmentSuccess');
            });
        }
    };
    const getDoctorName = (id) => {
        let name = '';
        let title = '';
        onlineFirstAppointmentInfo.doctors.map((item) => {
            if (item.id === parseInt(id)) {
                title = item.title
                    ? item.title === 'professor'
                        ? 'Prof.'
                        : 'Dr.'
                    : '';
                name = title + ' ' + item.firstname + ' ' + item.lastname;
            }
        });
        return name;
    };
    if (loading) {
        return react_1.default.createElement(atome_1.Loading, null);
    }
    return (react_1.default.createElement(react_native_1.SafeAreaView, null,
        react_1.default.createElement(react_native_1.ScrollView, { style: [OnlineFirstAppointment_style_1.styles.scrollview] },
            Breakpoints_1.isDesktop && react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
            react_1.default.createElement(react_native_1.View, { style: OnlineFirstAppointment_style_1.styles.container },
                react_1.default.createElement(react_native_1.View, { style: OnlineFirstAppointment_style_1.styles.marginTop4px },
                    react_1.default.createElement(atome_2.Icon, { icon: 'checkCircle' })),
                react_1.default.createElement(react_native_1.View, { style: OnlineFirstAppointment_style_1.styles.header },
                    react_1.default.createElement(react_native_1.Text, { style: [OnlineFirstAppointment_style_1.styles.headerTitle, OnlineFirstAppointment_style_1.styles.greenText] }, "Buchung best\u00E4tigen")),
                react_1.default.createElement(react_native_1.View, { style: OnlineFirstAppointment_style_1.styles.locationsContainer },
                    react_1.default.createElement(react_native_1.View, { style: [OnlineFirstAppointment_style_1.styles.confirmationBox, OnlineFirstAppointment_style_1.styles.shadowContainer] },
                        react_1.default.createElement(react_native_1.View, { style: [OnlineFirstAppointment_style_1.styles.positionRelative] },
                            react_1.default.createElement(atome_2.Icon, { icon: 'calendar', size: 60, color: '#3db384' }),
                            react_1.default.createElement(react_native_1.Text, { style: [OnlineFirstAppointment_style_1.styles.selectedDateDay] }, new Date(onlineFirstAppointmentInfo.selectedSlot.start).toLocaleString('de-DE', {
                                day: '2-digit',
                            }))),
                        react_1.default.createElement(react_native_1.Text, { style: [OnlineFirstAppointment_style_1.styles.blackText, GlobalStyles_1.globalStyles.marginTop25] }, "Datum / Uhrzeit:"),
                        react_1.default.createElement(react_native_1.Text, { style: [
                                OnlineFirstAppointment_style_1.styles.blackText,
                                OnlineFirstAppointment_style_1.styles.boldText,
                                GlobalStyles_1.globalStyles.marginBottom25,
                            ] },
                            new Date(onlineFirstAppointmentInfo.selectedDate).toLocaleString('de-DE', {
                                day: '2-digit',
                                month: 'long',
                                year: 'numeric',
                            }),
                            ",",
                            ' ',
                            new Date(onlineFirstAppointmentInfo.selectedSlot.start).toLocaleTimeString([], {
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: false,
                            }),
                            ' ',
                            "-",
                            ' ',
                            new Date(onlineFirstAppointmentInfo.selectedSlot.end).toLocaleTimeString([], {
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: false,
                            }),
                            ' ',
                            "Uhr"),
                        react_1.default.createElement(react_native_1.Text, { style: [OnlineFirstAppointment_style_1.styles.blackText] }, "Arzt / \u00C4rztin:"),
                        react_1.default.createElement(react_native_1.Text, { style: [
                                OnlineFirstAppointment_style_1.styles.blackText,
                                OnlineFirstAppointment_style_1.styles.boldText,
                                GlobalStyles_1.globalStyles.marginBottom25,
                            ] }, onlineFirstAppointmentInfo.doctorName),
                        react_1.default.createElement(react_native_1.Pressable, { style: OnlineFirstAppointment_style_1.styles.greenButton, onPress: bookAppointment },
                            react_1.default.createElement(react_native_1.Text, { style: [OnlineFirstAppointment_style_1.styles.greenButtonText] }, "Termin jetzt buchen"))))))));
}
exports.StepThreeOnlineFirstAppointment = StepThreeOnlineFirstAppointment;
